export default __webpack_public_path__ + "static/media/138.f71bde9f.jpg";